
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_493_1029)"}},[_c('path',{attrs:{"d":"M10 0C4.477 0 0 4.48 0 10.006c0 5.525 4.477 10.006 10 10.006s10-4.48 10-10.006S15.523 0 10 0zM5.85 4.513c.68 0 1.232.503 1.232 1.124 0 .621-.551 1.125-1.232 1.125-.68 0-1.232-.504-1.232-1.125 0-.62.552-1.124 1.232-1.124zm1.242 9.618H4.657V7.776h2.435v6.355zm8.271 0h-2.446v-3.495c0-.399-.074-.68-.221-.847-.148-.165-.355-.248-.622-.248a.884.884 0 00-.718.335c-.183.224-.275.625-.275 1.203v3.052H8.647V7.776h2.266V8.81c.34-.423.682-.725 1.029-.907.347-.181.77-.272 1.268-.272.674 0 1.2.2 1.582.601.38.401.571 1.02.571 1.859v4.04z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_493_1029"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    